document.addEventListener('DOMContentLoaded', function() {

    function hideRevirewBlock(){
        document.querySelectorAll('.jdgm-widget').forEach((item) => {
            const parent = item.parentElement;
            if(item.style.display == 'none' && parent && parent.classList.contains('shopify-block')){
                parent.style.display = 'none';
            }
        });
    }

    function hideEmptyGroupBlocks(){
        const group_blocks = document.querySelectorAll('.product-details .group-block');
        group_blocks.forEach((block) => {
            if(block.querySelector('.group-block-content').innerText.replace(/\s/g, '') === ''){
                block.style.display = 'none'
                block.previousElementSibling.style.display = 'none';
            }
        });
    }

    setTimeout(() => {
        hideRevirewBlock();
    }, 400);

    hideEmptyGroupBlocks();
    
  });